import apiService from "./api";
import { sanitizeQueryParams } from "@src/utility/helpers/apiHelper";

export interface LegalPage {
  id: string | number;
  title: string;
  key?: string;
  metaTitle?: string;
  metaKeyword?: string;
  metaDescription?: string;
  content: string;
  status: string;
}

export interface AddLegalPage {
  title: string;
  key: string;
  metaTitle: string;
  metaKeyword: string;
  metaDescription: string;
  content: string;
  status?: string;
}

export interface GetLegalPagesParams {
  page?: number;
  pageSize?: number;
  title?: string;
  status?: string;
  orderBy?: string;
  orderDirection?: string;
  [key: string]: unknown;
}

export class LegalPagesService {
  async getLegalPages(query?: GetLegalPagesParams) {
    return apiService.get("/legal-pages", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getLegalPageDetails(id: string | number) {
    return apiService.get(`/legal-pages/${id}`);
  }

  async addLegalPage(data: AddLegalPage) {
    return apiService.post("/legal-pages", data);
  }

  async updateLegalPage(id: string | number, data: Partial<AddLegalPage>) {
    return apiService.put(`/legal-pages/${id}`, data);
  }

  async deleteLegalPage(id: string | number) {
    return apiService.delete(`/legal-pages/${id}`);
  }
}

export const legalPagesService = new LegalPagesService();
